"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = NativeSlider;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native");
var _slider = _interopRequireDefault(require("@react-native-community/slider"));
var _styles = require("@sart/styles");
var _excluded = ["style"];
function NativeSlider(props) {
  var style = props.style,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_slider["default"], (0, _extends2["default"])({
    style: [styles.slider, style],
    minimumTrackTintColor: _styles.colors.feature,
    maximumTrackTintColor: _styles.colors.subtle
  }, _styles.theme.slider, rest));
}
var styles = _reactNative.StyleSheet.create({
  slider: {
    // width: 200,
    // height: 40
  }
});